import React from 'react'

const FlexBox = ({children, className, ...props}) => {
    let classNameProps = 'flex justify-content-center align-items-center'

    if (className) {
        classNameProps += ` ${className}`
    }

    return (
        <div {...props} className={classNameProps}>
            {children}
        </div>
    )
}

export default FlexBox
